/**
 * The tracker's API client.
 *
 * Transport, auth and error shaping now live in `@cds/dashboard-kit`'s `ApiClient` — they were
 * never mission-specific, and the FinOps dashboard needed the same forty lines. What remains
 * here is the part that genuinely is this dashboard's: which routes exist, what they return, and
 * the two response shapes the kernel API uses interchangeably (`{ missions }` or a bare array).
 *
 * `MissionTrackerError` stays a real subclass rather than an alias so that a host's existing
 * `catch (e) { if (e instanceof MissionTrackerError) … }` and any log line reading `e.name`
 * keep behaving exactly as before the extraction.
 */
import { ApiClient, DashboardApiError } from '@cds/dashboard-kit';
export class MissionTrackerError extends DashboardApiError {
    constructor(message, status, detail) {
        super(message, status, detail);
        this.name = 'MissionTrackerError';
    }
}
export class TrackerClient extends ApiClient {
    error(message, status, detail) {
        return new MissionTrackerError(message, status, detail);
    }
    listMissions(opts = {}) {
        return this.request(`/api/kernel/missions${this.qs({ state: opts.state || undefined, limit: opts.limit || undefined })}`).then((r) => (Array.isArray(r) ? r : (r.missions ?? [])));
    }
    getMission(id) {
        return this.request(`/api/kernel/missions/${encodeURIComponent(id)}`).then((r) => ('mission' in r ? r.mission : r));
    }
    getWatchState(missionId) {
        return this.request(`/api/kernel/missions/${encodeURIComponent(missionId)}/watch`);
    }
    watch(missionId) {
        return this.request(`/api/kernel/missions/${encodeURIComponent(missionId)}/watch`, {
            method: 'POST',
        });
    }
    unwatch(missionId) {
        return this.request(`/api/kernel/missions/${encodeURIComponent(missionId)}/watch`, {
            method: 'DELETE',
        });
    }
    listNotifications(opts = {}) {
        return this.request(`/api/notifications${this.qs({
            unread: opts.unreadOnly ? 'true' : undefined,
            limit: opts.limit || undefined,
            subject: opts.subject || undefined,
        })}`).then((r) => r.notifications ?? []);
    }
    markRead(id) {
        return this.request(`/api/notifications/${encodeURIComponent(id)}/read`, { method: 'POST' }).then((r) => r.notification);
    }
    getPreferences() {
        return this.request(`/api/notifications/preferences`);
    }
    savePreferences(prefs) {
        return this.request(`/api/notifications/preferences`, {
            method: 'PUT',
            body: JSON.stringify(prefs),
        });
    }
}
//# sourceMappingURL=client.js.map